import type { DataChartStyleProps } from './datachartStyleRegistry'
import { EnergyChartBase } from './EnergyChartBase'

export function EnergyChartStyle02(props: DataChartStyleProps) {
  return <EnergyChartBase variant="gold" chartType="bar" {...props} />
}
